// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2LVHW","Open":"SideDrawer_Open__2Kvud","Close":"SideDrawer_Close__2hPjM","Logo":"SideDrawer_Logo__351HQ"};